export default "__VITE_ASSET__DZzbj6Q$__"